export enum BrandTypes {
    AP = 'AP',
    AC = 'AC',
    DS = 'DS',
    OV = 'OV',
}
